import Reporte from './Reporte'
export default Reporte
